import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.STAGE,
  hostname: API_ENDPOINTS.HOSTNAME.STAGE,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.STAGE,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.STAGE,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.STAGE,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.STAGE,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.STAGE,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.STAGE,
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.STAGE,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.STAGE,
  WAF_URL: API_ENDPOINTS.WAF_URL.STAGE,
};

export const environment = defaultsDeep(override, environmentDefaults);
